__turbopack_context__.v({
  "button": "FavoritesExpand-module-scss-module__8mP7iG__button",
  "button_box": "FavoritesExpand-module-scss-module__8mP7iG__button_box",
  "button_box_active": "FavoritesExpand-module-scss-module__8mP7iG__button_box_active",
  "button_info": "FavoritesExpand-module-scss-module__8mP7iG__button_info",
});
